export const TRIAL_QUERY = '/trial';
export const TRIALS_QUERY = '/trials';
